import { INotification } from "infrastructure/notification";

export interface IMessageTranslation {
  language: string;
  industryDescription: string;
  text: string;
}

export interface IMessageTranslationState {
  messageTranslations: IMessageTranslation[];
  notifications: INotification[];
  isLoading: boolean;
}

export const getMessageTranslationsInitialState = (): IMessageTranslationState => ({
  messageTranslations: [],
  notifications: [],
  isLoading: false
});
